import IEExperience from "../components/IEExperience";
import NonStickyNavAndFooter from "./layout/NonStickyNavAndFooter";

export default function ExperiencesPage() {
    return (
        <NonStickyNavAndFooter>
           <IEExperience />
        </NonStickyNavAndFooter>
    )
}

